import { ValueObject } from '@/engine/core/valueObject';
import type { CustomAccessorParams, ICustomValueConfigProps } from './interfaces';

/**
 * Represents a custom value configuration for a report.
 * @template T - The type of the value returned by the value accessor.
 * @template A - The type of the arguments passed to the value accessor.
 */
export class ReportConfigCustomValue<T, A> extends ValueObject<ICustomValueConfigProps<T, A>> {
  public constructor(props: ICustomValueConfigProps<T, A>) {
    super(props);
  }

  /**
   * Gets the value accessor function that retrieves the custom value.
   * @param params - The parameters passed to the value accessor.
   * @param args - The arguments passed to the value accessor.
   * @returns A promise that resolves to the custom value.
   */
  public get valueAccessor(): (params: CustomAccessorParams, args: A) => Promise<T> {
    return this.props.valueAccessor;
  }

  /**
   * Gets the arguments passed to the value accessor.
   */
  public get args(): A {
    return this.props.args;
  }

  /**
   * Gets the descriptor of the custom value.
   */
  public get descriptor(): string {
    return this.props.descriptor;
  }

  /**
   * Gets the phase of the custom value.
   */
  public get phase(): string | undefined {
    return this.props.phase;
  }
}
